module.exports = __webpack_public_path__ + "static/deltaq-logo-d76eb69c7c9def56b2b0f6c5a896908e.jpeg";